import Marquee from "react-fast-marquee";

const tieups = [
  // "Dfsa1.png",
  // "ib1.png",
  // "uqudo1.png",
  // "ir1.png",
  // "tmp_a0c8cabd-f247-409e-bc36-a320f12077cb.png",
  // "tmp_76500cfd-7fc0-4ad4-b82c-d5cc3dd3803e.png",
  // "six1.png",
  "bsewhite.png",
  "nsewhite.png",
  "sebiwhite.png",
  "accordwhite.png",
];

const RegulatoryTieups = () => {
  return (
    <div className="flex flex-col gap-8 px-14 mt-10 py-12 items-center justify-center antialiased container">
      <div className="flex flex-col bg-[#0d0d0d] rounded-3xl justify-between items-center">
        <div className="flex flex-col justify-between items-center w-full">
          <div className="flex flex-col gap-4 mb-16">
             <div className="text-center max-w-4xl mx-auto mb-24 animate-fade-in-up">
            <span className="text-[#57c0af] text-xl font-bold tracking-[0.2em] uppercase mt-10 block">Our Ecosystem</span>
            <h2 className="text-5xl md:text-7xl font-light text-white mt-10 tracking-tight">A Shared Journey</h2>
            <p className="md:text-xl text-sm text-gray-400 font-light leading-relaxed mt-10">
                From first-time investors to experienced wealth-builders, our users aren't just clients — they are collaborators in financial empowerment.
            </p>
        </div>  
        </div>

          <Marquee direction="left">
            {tieups.map((image, index) => (
              <div
                key={index}
                className={`flex mb-16 min-w-52 justify-center ${image === "tmp_a0c8cabd-f247-409e-bc36-a320f12077cb.png" ||
                  image === "tmp_76500cfd-7fc0-4ad4-b82c-d5cc3dd3803e.png"
                  ? "h-[4.5rem]" // Custom height for specific images
                  : "h-[3.5rem]" // Default height
                  }`}
              >
                <img
                  src={`/tieups/${image}`}
                  className={`mx-16 object-cover ${image === "tmp_a0c8cabd-f247-409e-bc36-a320f12077cb.png" ||
                    image === "tmp_76500cfd-7fc0-4ad4-b82c-d5cc3dd3803e.png"
                    ? "w-[200px]" // Custom width for specific images
                    : "w-70" // Default width
                    }`}
                  alt="Tieup Logo"
                />
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    </div>
  );
};

export default RegulatoryTieups;
